import { createAxiosInstance } from '@/apis/axios.utils';
import { env } from '@/env';
import merge from 'lodash/merge';

export const camelCaseAxios = createAxiosInstance(env.threadsApiUrl, {
  camelizeKeys: true,
});
export const axios = createAxiosInstance(env.threadsApiUrl);

export async function getThreadsProfile({ brandId }, axiosConfig = {}) {
  return camelCaseAxios.get(`/brands/${brandId}/profile`, axiosConfig);
}

export async function getThreadsProfileAllBrands({ brandIds }, axiosConfig = {}) {
  return camelCaseAxios.put(`/brands/profiles`, { brand_ids: brandIds }, axiosConfig);
}

export async function getThreadsFollowerDemographics({ brandId, date }, axiosConfig = {}) {
  return axios.get(
    `/brands/${brandId}/profile/follower_demographic_insights`,
    merge(
      {
        params: { date },
      },
      axiosConfig,
    ),
  );
}

export async function postThreadsDemographicsInsightsCSV(
  { brandId, date, socketId, breakdown },
  axiosConfig = {},
) {
  return axios.post(
    `/brands/${brandId}/profile/follower_demographic_insights/csv`,
    { date, socketId, breakdown },
    axiosConfig,
  );
}
